import { ChangePasswordPageState } from '../../../../pages/ChangePasswordPage/interfaces/ChangePasswordPageState';

export function validateFormat(rules: ChangePasswordPageState, value: string) {
  return value === '' || (rules?.Regle8CharMin && rules?.Regle3Element);
}
